import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../services/AuthContext"; 
import { authStatus, verifyResetToken } from "../services/AuthService";

const ResetPasswordComp = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setResetToken, setActiveModal } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkToken = async () => {
      try {
        const response = await verifyResetToken(token);

        if (response.status === authStatus.VALID) {
          setResetToken(response.emailToken);
          setActiveModal("reset");
        } else {
          alert("Lien invalide ou expiré.");
          navigate("/");
        }
      } catch (err) {
        alert("Erreur lors de la vérification du lien.");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    checkToken();
  }, [token, navigate, setActiveModal, setResetToken]);

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {loading && <p>Vérification du lien en cours...</p>}
    </div>
  );
};

export default ResetPasswordComp;